export const MAYKER_REMITTANCE_ADDRESS = {
  company: 'Mayker Events',
  line1: '1307 6th Ave. N, Suite C',
  line2: 'Nashville, TN 37208',
  phone: '(615) 970-1244',
  email: 'events@mayker.com',
};

export function getMaykerRemittanceAddress() {
  return { ...MAYKER_REMITTANCE_ADDRESS };
}

const DEFAULT_WIRE_INSTRUCTIONS_PDF_URL = '/Mayker-Domestic-Wire-Instructions.pdf';

export function getWireInstructionsPdfUrl() {
  try {
    return String(process.env.REACT_APP_WIRE_INSTRUCTIONS_PDF_URL || '').trim()
      || DEFAULT_WIRE_INSTRUCTIONS_PDF_URL;
  } catch (_) {
    return DEFAULT_WIRE_INSTRUCTIONS_PDF_URL;
  }
}

export function hasWireInstructionsPdf() {
  return Boolean(getWireInstructionsPdfUrl());
}
